import * as log from "loglevel";
import * as React from "react";

import { inject, observer } from "mobx-react";
import { Button } from "semantic-ui-react";

import { AdminStore } from "../../stores/admin-store";
import { LoadingSpinner } from "../common/loading-spinner";

interface IProps{
	adminStore?: AdminStore;
}

interface IState{
}


@inject("adminStore") @observer
export class FetchJamPurgeList extends React.Component<IProps, IState>{
	constructor(props, state){
		super(props, state);
		this.getPurgeList = this.getPurgeList.bind(this);
		}


	async getPurgeList(){
		let filename = `Jam Purge List ${new Date().toLocaleString().split(",")[0].replace(/\//g, "-")}`;
		await this.props.adminStore.fetchJamPurgeList(filename);
	}

	render(){
		return (
			<div>
				<Button className="jibunu-orange" onClick={this.getPurgeList} content="Fetch Purge List" />

				{this.props.adminStore.loading &&
					<div>
						<LoadingSpinner text={"fetching Purge List"} />
					</div>
				}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/admin/fetch-jam-purge-list.tsx